import { render, staticRenderFns } from "./PowerImitateHead.vue?vue&type=template&id=33d14fb2&scoped=true"
import script from "./PowerImitateHead.vue?vue&type=script&lang=js"
export * from "./PowerImitateHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d14fb2",
  null
  
)

export default component.exports